export default __webpack_public_path__ + "static/media/heart-icon.e147d080.svg";